import IconButton from "components/Button/IconButton";
import NormalBtn from "components/NewButton/NormalBtn";
import SubTitle from "components/PageTitle/SubTitle";

const TableTitleWithButton = (props) => {
  const btnStyle = {
    marginLeft: "auto",
    marginBottom: "0.5rem",
  };

  return (
    <div style={{ display: "flex", marginBottom: props.marginBottom }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <IconButton type="border" />
        <div style={{ width: "0.5rem" }}></div>
        <SubTitle titleText={props.titleLabel} />
      </div>

      <div style={btnStyle}>
        <NormalBtn
          theme={props.theme ? props.theme : "white"}
          width={`${props.btnWidth ? props.btnWidth : "4.25rem"}`}
          name={props.buttonText}
          onClick={() => {
            props.onClickEvent();
          }}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
};
export default TableTitleWithButton;
